// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2w1lo","colMin":"styles_colMin__20qm_"};